module.exports = __webpack_public_path__ + "img/empty-cart.04d80e52.svg";